const WEGLOT_API_KEY = process.env.GATSBY_WEGLOT_API_KEY

const initWeglot = () => {
  if (typeof window === 'undefined') return
  if (!window.Weglot) return
  if (!WEGLOT_API_KEY) return
  if (window.__weglotInitialized) return

  try {
    window.Weglot.initialize({
      api_key: WEGLOT_API_KEY,
      hide_switcher: true,
    })
    window.__weglotInitialized = true
  } catch {
    // If initialization fails (e.g., transient script load issues), allow a retry.
    window.__weglotInitialized = false
  }
}

export const onClientEntry = () => {
  if (typeof document === 'undefined') return

  initWeglot()
  if (window.Weglot) return
  if (document.querySelector('script[data-weglot-script]')) return

  const script = document.createElement('script')
  script.src = 'https://cdn.weglot.com/weglot.min.js'
  script.async = true
  script.defer = true
  script.dataset.weglotScript = 'true'
  ;(document.head || document.body).appendChild(script)
  script.addEventListener('load', initWeglot)
}

export const onRouteUpdate = ({ location }) => {
  if (typeof window === 'undefined') return

  // Ensure Weglot is initialized (script can race with Gatsby hydration).
  initWeglot()

  const weglot = window.Weglot
  if (!weglot || typeof weglot.getCurrentLang !== 'function') return
  if (typeof weglot.switchTo !== 'function') return

  const currentLang = weglot.getCurrentLang()
  if (!currentLang || currentLang === 'en') return

  const routeKey = `${currentLang}:${location.pathname}${location.search}${location.hash}`
  if (window.__weglotLastRouteKey === routeKey) return
  window.__weglotLastRouteKey = routeKey

  // Defer so the new page DOM is mounted before translation re-applies.
  setTimeout(() => {
    try {
      weglot.switchTo(currentLang)
    } catch {
      // no-op
    }
  }, 0)
}
